export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DUBAI_COMMUNITIES = [
  'Palm Jumeirah',
  'Downtown Dubai',
  'Dubai Hills Estate',
  'Emirates Hills',
  'Jumeirah Bay Island',
  'Bluewaters Island',
  'Dubai Marina',
  'Arabian Ranches',
  'Al Barari',
];

export const LUXURY_DEVELOPERS = [
  'Emaar Properties',
  'Nakheel',
  'Meraas',
  'Omniyat',
  'Sobha Realty',
  'DAMAC Properties',
  'Aldar',
];

export const PROPERTY_TYPES = [
  'Apartment',
  'Villa',
  'Penthouse',
  'Mansion',
  'Townhouse',
  'Plot/Land',
  'Farmhouse',
  'Independent House',
  'Commercial',
];

export const PROPERTY_TYPES_INDIA = [
  'Apartment',
  'Villa',
  'Plot/Land',
  'Farmhouse',
  'Independent House',
  'Commercial',
  'Penthouse',
  'Townhouse',
];

export const VIEW_TYPES = [
  'Sea View',
  'City View',
  'Garden View',
  'Gated Community',
  'Hill View',
  'Skyline View',
  'Golf Course View',
  'Park View',
  'Marina View',
];

export const VIEW_TYPES_INDIA = [
  'Sea View',
  'City View',
  'Garden View',
  'Gated Community',
  'Hill View',
  'Park View',
];

// Indian cities by tier
export const INDIA_CITIES = {
  tier1: [
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'delhi_ncr', label: 'Delhi NCR' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'pune', label: 'Pune' },
  ],
  tier2: [
    { value: 'ahmedabad', label: 'Ahmedabad' },
    { value: 'jaipur', label: 'Jaipur' },
    { value: 'kochi', label: 'Kochi' },
    { value: 'chandigarh', label: 'Chandigarh' },
    { value: 'indore', label: 'Indore' },
    { value: 'lucknow', label: 'Lucknow' },
  ],
  tier3: [
    { value: 'coimbatore', label: 'Coimbatore' },
    { value: 'nagpur', label: 'Nagpur' },
    { value: 'surat', label: 'Surat' },
    { value: 'vizag', label: 'Vizag' },
    { value: 'bhopal', label: 'Bhopal' },
    { value: 'thiruvananthapuram', label: 'Thiruvananthapuram' },
  ],
  lifestyle: [
    { value: 'goa', label: 'Goa' },
    { value: 'alibaug', label: 'Alibaug' },
    { value: 'lonavala', label: 'Lonavala' },
    { value: 'rishikesh', label: 'Rishikesh' },
    { value: 'ooty', label: 'Ooty' },
    { value: 'shimla', label: 'Shimla' },
  ],
};

export const MARKETPLACE_CATEGORIES = [
  { id: 'cars', label: 'Luxury Cars', icon: 'Car' },
  { id: 'yachts', label: 'Yachts', icon: 'Ship' },
  { id: 'jets', label: 'Private Jets', icon: 'Plane' },
  { id: 'interiors', label: 'Interior Design', icon: 'Home' },
  { id: 'watches', label: 'Watches', icon: 'Watch' },
  { id: 'art', label: 'Art & Collectibles', icon: 'Palette' },
  { id: 'services', label: 'Private Services', icon: 'Users' },
];